/**
 * Brand assets of the legacy EMIL Insurance Suite, frozen on 2026-09-15 (SDD-012, U-3/U-7).
 *
 * Resolved as URLs through the bundler so they are hashed and cached like every other asset. The
 * logo is the FALLBACK: the suite variant prefers the legacy's own served file
 * (`<suiteUrl>/assets/logos/emil_group.png`, runtime config) so the two windows show the same
 * tenant image, and falls back to this copy when that image fails to load.
 */
export const brandAssets = {
  emilLogo: new URL('../assets/brand/emil_group.png', import.meta.url).href,
  emilLogoLarge: new URL('../assets/brand/emil-demo-large.png', import.meta.url).href,
  defaultAvatar: new URL('../assets/brand/Profile_8.3a3a4df3.svg', import.meta.url).href,
} as const;
